import { coreService } from "../../services/coreService";
import { buildQuery } from "../../lib/network";

export type PostCrmCustomListViewParamsType = Parameters<(typeof coreService)["crmSearchDemoViewsCreate"]>[0];

export const postCrmCustomListView = (headers: any) => (body: PostCrmCustomListViewParamsType) => {
  return buildQuery(coreService.crmSearchDemoViewsCreate(body, { headers }), (response) => {
    return response.data;
  });
};
